<div class="toolbar-container pb-3">
  <div class="rental-title">
    <ng-container *ngIf="rental">
      <app-rental-image [rental]="rental" [size]="40"></app-rental-image>
      {{ rental.name }}
    </ng-container>
    <app-page-help videoId="VBfXqZurfmA" class="ml-2"></app-page-help>
  </div>

  <div>
    <div class="btn-group" dropdown [isDisabled]="1 | isReadonlyRole">
      <button type="button" class="btn btn-success text-uppercase dropdown-toggle" dropdownToggle>
        <span class="fal fa-plus"></span> Add <span class="caret"></span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
        <li>
          <button type="button" (click)="onAddLosDiscount()">
            <i [innerHtml]="'assets/images/icons/los-discount.svg' | svgIcon | async"></i>
            LOS Discount
          </button>
        </li>
        <li>
          <button type="button" (click)="onAddDiscountCode()">
            <i [innerHtml]="'assets/images/icons/discount-codes.svg' | svgIcon | async"></i>
            Discount Code
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="filters-container" [formGroup]="filters">
  <mat-form-field class="field-categories" floatLabel="never">
    <mat-select formControlName="discountType" placeholder="Discount Type">
      <mat-option [value]="">All</mat-option>
      <mat-option value="los">LOS Discount</mat-option>
      <mat-option value="code">Discount Code</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="field-categories" floatLabel="never">
    <mat-select formControlName="type" placeholder="Type">
      <mat-option [value]="">All</mat-option>
      <mat-option value="flat">Flat</mat-option>
      <mat-option value="pct">Percent</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="spacer"></div>
  <app-table-search (search)="onSearch($event)" (clearFilters)="onClearFilter()"></app-table-search>
</div>

<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="channelName" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="text-truncate">{{ element.name }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="discountTypeView">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Discount Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.discountTypeView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type === 'pct' ? 'Percent' : 'Flat' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Amount</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type === 'pct' ? element.amount + '%' : (element.amount | number : '.2-2') }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="start">Start</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.startView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="endView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="end">End</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.endView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>Edit</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li *ngIf="element.discountType === 'los'">
                <button (click)="onEdit(element)" type="button"><i class="fal fa-file-alt"></i> View</button>
              </li>
              <li *ngIf="element.discountType === 'code'">
                <button (click)="onEdit(element)" type="button"><i class="fal fa-edit"></i> Edit</button>
              </li>
              <li *ngIf="element.discountType === 'los'">
                <button (click)="onDelete(element)" type="button"><i class="fal fa-trash-alt"></i>Delete</button>
              </li>
              <li
                *ngIf="element.discountType === 'code'"
                [matTooltip]="
                  element.isUsed
                    ? 'Used Discount Code can not be deleted. You can deactivate this code if you do not want to use it anymore'
                    : ''
                "
                matTooltipPosition="left"
              >
                <button (click)="onDelete(element)" type="button" [disabled]="element.isUsed">
                  <i class="fal fa-trash-alt"></i>Delete
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
